/**
 * Contexto de la flota en vivo (F2) — lógica sin JSX. Igual que el de métricas:
 * el `subscribe` se inyecta (watcher RTDB en prod, fake en tests). Sin provider,
 * `useFleetMarkers()` devuelve `[]`.
 *
 * El reconciliador {@link reconcileFleetMarkers} preserva la identidad de cada
 * marker entre ticks; aquí se mantiene el `Map` acumulado y se publica su lista.
 */
import type { DriverDetailsRtdb } from '@ibercar/rtdb-contracts';
import type { Database } from 'firebase/database';
import { createContext, useContext } from 'react';
import { reconcileFleetMarkers, type FleetMarker } from '../data/fleet';
import { watchFleetDrivers } from '../data/watchers';

/** `subscribe`: registra un callback de markers y devuelve la función de baja. */
export type FleetSubscribe = (onMarkers: (markers: FleetMarker[]) => void) => () => void;

export const FleetContext = createContext<FleetMarker[]>([]);

/** Markers de la flota actuales (lista vacía si no hay provider / datos). */
export function useFleetMarkers(): FleetMarker[] {
  return useContext(FleetContext);
}

/**
 * Suscripción en vivo: nodo `drivers` → reconcilia markers preservando
 * identidad → publica la lista. Live, no unit-tested.
 */
export function createLiveFleetSubscribe(db: Database): FleetSubscribe {
  return (onMarkers) => {
    let markers = new Map<string, FleetMarker>();
    return watchFleetDrivers(db, (drivers: DriverDetailsRtdb[]) => {
      const { markers: next } = reconcileFleetMarkers(markers, drivers);
      markers = next;
      onMarkers([...next.values()]);
    });
  };
}
